import { getDoubleBookings } from '../../ReservationModule/shared/services/data.service';
import { isErrorInfo } from '../interfaces/error-info.interface';
import { ReservationUiModel } from '../ui-models/reservation.ui-model';
import { BlockedDatesUiModel } from '../ui-models/blocked-dates.ui-model';

type DoubleBookingItem = {
  currentReservation: ReservationUiModel;
  otherReservation?: ReservationUiModel;
  blockedDate?: BlockedDatesUiModel;
};

let doubleBookingsCache: DoubleBookingItem[] | null = null;
let doubleBookingsPromise: Promise<DoubleBookingItem[]> | null = null;

export const getCachedDoubleBookings = async (): Promise<DoubleBookingItem[]> => {
  if (doubleBookingsCache) return doubleBookingsCache;
  if (doubleBookingsPromise) return doubleBookingsPromise;

  doubleBookingsPromise = getDoubleBookings()
    .then((response) => {
      if (isErrorInfo(response)) {
        return [];
      }

      doubleBookingsCache = response;
      return response;
    })
    .finally(() => {
      doubleBookingsPromise = null;
    });

  return doubleBookingsPromise;
};

export const clearCachedDoubleBookings = () => {
  doubleBookingsCache = null;
  doubleBookingsPromise = null;
};
